/* cb-tracking.js - het gedrag achter "Volg je bestelling"
 *
 * Hoort bij sections/cb-tracking.liquid. Twee koeriers, twee routes:
 *
 *   Codes die met 3S of 2S beginnen zijn PostNL. PostNL vraagt de postcode van
 *   de ontvanger, dus dat veld verschijnt zodra je zo'n code typt. De link
 *   wordt opgebouwd als <base><code>-NL-<postcode> en gaat in een nieuw
 *   tabblad open, met dezelfde link nog eens als knop eronder voor het geval
 *   de popupblokker meekijkt.
 *
 *   Al het andere gaat naar de widget van 17TRACK. Hun script wordt pas
 *   opgehaald bij de eerste code die er een nodig heeft; in de oude pagina
 *   stond het in de HTML en laadde het bij elk bezoek mee, ook als je niets
 *   invulde.
 *
 * Zonder JavaScript blijft de uitleg onder het formulier staan en werkt de rest
 * van de pagina gewoon; volgen kan dan niet, want beide koeriers hebben een
 * clientkant nodig.
 */
(function () {
  var root = document.querySelector('[data-cb-tracking]');
  if (!root) { return; }

  var form = root.querySelector('[data-cb-track-form]');
  var code = root.querySelector('[data-cb-code]');
  var postalWrap = root.querySelector('[data-cb-postal]');
  var postal = root.querySelector('[data-cb-postal-input]');
  var error = root.querySelector('[data-cb-error]');
  var codeOut = root.querySelector('[data-cb-code-out]');
  var postnlLink = root.querySelector('[data-cb-postnl-link]');
  var widget = root.querySelector('[data-cb-widget]');

  var prefixes = (root.getAttribute('data-postnl-prefixes') || '3S,2S')
    .split(',')
    .map(function (value) { return value.trim().toUpperCase(); })
    .filter(Boolean);
  var base = root.getAttribute('data-postnl-base') || 'https://jouw.postnl.nl/track-and-trace/';
  var lang = root.getAttribute('data-lang') || 'en';

  function isPostnl(value) {
    var upper = value.trim().toUpperCase();
    return prefixes.some(function (prefix) { return upper.indexOf(prefix) === 0; });
  }

  function showPanel(name) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-cb-panel]'), function (panel) {
      panel.hidden = panel.getAttribute('data-cb-panel') !== name;
    });
  }

  function showError(message) {
    if (!error) { return; }
    error.textContent = message || '';
    error.hidden = !message;
  }

  function syncPostal() {
    if (!postalWrap) { return; }
    postalWrap.hidden = !isPostnl(code.value);
  }

  code && code.addEventListener('input', function () {
    syncPostal();
    showError('');
  });

  /* Het script van 17TRACK wordt een keer opgehaald en daarna hergebruikt. */
  var loader = null;
  function loadTracker() {
    if (loader) { return loader; }
    loader = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://www.17track.net/externalcall.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return loader;
  }

  function trackExternal(value) {
    showPanel('widget');
    if (!widget) { return; }
    widget.innerHTML = '';
    loadTracker().then(function () {
      if (typeof window.YQV5 === 'undefined') { return; }
      window.YQV5.trackSingle({
        YQ_ContainerId: widget.id,
        YQ_Num: value,
        YQ_Height: 560,
        YQ_Lang: lang
      });
    }).catch(function () {
      /* Laadt hun script niet, dan is er niets te tonen; zeg dat dan ook in
         plaats van een leeg vlak neer te zetten. */
      widget.textContent = root.getAttribute('data-err-empty');
      showPanel('idle');
    });
  }

  function trackPostnl(value) {
    var zip = (postal ? postal.value : '').replace(/\s+/g, '').toUpperCase();
    if (!zip) {
      showError(root.getAttribute('data-err-postal'));
      postal && postal.focus();
      return;
    }

    var url = base + encodeURIComponent(value) + '-NL-' + encodeURIComponent(zip);
    if (codeOut) { codeOut.textContent = value; }
    if (postnlLink) { postnlLink.href = url; }
    showPanel('postnl');

    /* Meteen openen, binnen de klik. Een setTimeout eromheen raakt de
       gebruikersactie kwijt en wordt door de popupblokker tegengehouden; de
       knop eronder blijft de terugval. */
    window.open(url, '_blank', 'noopener');
  }

  form && form.addEventListener('submit', function (event) {
    event.preventDefault();
    var value = code.value.trim();

    if (!value) {
      showError(root.getAttribute('data-err-empty'));
      code.focus();
      return;
    }

    showError('');
    if (isPostnl(value)) {
      trackPostnl(value);
    } else {
      trackExternal(value);
    }
  });

  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-example]'), function (button) {
    button.addEventListener('click', function () {
      code.value = button.textContent.trim();
      syncPostal();
      showError('');
      code.focus();
    });
  });

  var copy = root.querySelector('[data-cb-copy]');
  if (copy && navigator.clipboard) {
    copy.addEventListener('click', function () {
      navigator.clipboard.writeText(codeOut ? codeOut.textContent : '').then(function () {
        copy.textContent = root.getAttribute('data-copied-label');
        copy.classList.add('is-done');
        setTimeout(function () {
          copy.textContent = root.getAttribute('data-copy-label');
          copy.classList.remove('is-done');
        }, 1600);
      });
    });
  } else if (copy) {
    copy.hidden = true;
  }

  syncPostal();
})();
